import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingQueue: Array<string> = [];

  constructor(private loadingController: LoadingController) {}

  public async showOverlayLoader(
    loaderIdentifier: string,
    message: string = 'Loading...'
  ): Promise<void> {
    this.loadingQueue.push(loaderIdentifier);

    if (this.loadingQueue.length === 1) {
      const loading = await this.loadingController.create({
        message,
        translucent: true,
        spinner: 'circular',
        cssClass: 'custom-loading',
      });

      await loading.present();
    }
  }

  public async dismissOverlayLoader(loaderIdentifier: string): Promise<void> {
    this.loadingQueue = this.loadingQueue.filter(
      (id) => id !== loaderIdentifier
    );

    if (this.loadingQueue.length === 0) {
      await this.loadingController.dismiss();
    }
  }
}
